import { SiteMaterialList, useApiTradeV1TradeCompaniesSiteMaterialsRetrieve } from 'api';

export const useSiteMaterialsBySite = (companyId: number) => {
  const { data, ...rest } = useApiTradeV1TradeCompaniesSiteMaterialsRetrieve(companyId);

  const siteMaterials = data?.results.reduce(
    (acc: Record<string, SiteMaterialList[]>, siteMaterial) => {
      const site = siteMaterial.site.id;
      if (!acc[site]) {
        acc[site] = [];
      }
      acc[site].push(siteMaterial);
      return acc;
    },
    {} as Record<string, SiteMaterialList[]>
  );

  return {
    data: siteMaterials ? Object.values(siteMaterials) : [],
    ...rest,
  };
};
